import React from "react";
import { Route, Routes } from "react-router-dom";
import { PublicOnlyRoute } from "./RouteProtectors";
import { HomePage } from "../pages/home";
import { HowToInstallPage } from "../pages/howToInstall/HowToInstallPage";
import { AppPage } from "../pages/apps";
import { SignInScreen } from "../pages/signIn/SignInScreen";

const AppRoutes = () => {
  return (
    <Routes>
      <Route element={<PublicOnlyRoute />}>
        <Route path="admin" element={<SignInScreen />} />
      </Route>

      <Route path="/" element={<HomePage />} />
      <Route path="/how-to-install" element={<HowToInstallPage />} />
      <Route path="/apps/:appId" element={<AppPage />} />

      <Route path="*" element={<p>Page not found.</p>} />
    </Routes>
  );
};

export default AppRoutes;
